<template>
  <div id="thermal">
    <div class="not-print">
      <button class="btn btn-primary" style="margin: 15px" @click="print">
        Imprimir
      </button>
      <button class="btn btn-primary" style="margin: 15px" @click="printNota">
        Notinha
      </button>
      <br />
    </div>

    <div id="print">
      <b-card id="card">
        <table>
          <pr-row>
            <pr-col class="text-center titulo">
              <b>{{ company.name }}</b>
            </pr-col>
          </pr-row>

          <pr-row>
            <pr-col class="text-center cabecalho">
              <small>{{ company.cnpj | cnpj }}</small></pr-col
            >
          </pr-row>

          <pr-row>
            <pr-col class="text-center texto">
              <small>
                {{ addressCompany.address }}, {{ addressCompany.number }} /
                {{ addressCompany.city }}-{{ addressCompany.state }}
                {{ company.phone_wa | phone }}
              </small>
            </pr-col>
          </pr-row>
        </table>
        <hr />

        <pr-row>
          <pr-col class="text-center cabecalho">
            <b>
              RESUMO
              <span v-if="order.status == 'o'"> DE VENDA </span>
              <span v-else> DO ORÇAMENTO </span>

              Nº #{{ order.number }}
            </b>
          </pr-col>
        </pr-row>

        <pr-row>
          <pr-col style="font-size: 10pt">
            <b>Data :</b>

            <span v-if="order.status == 'o'">
              {{ order.ordered_at | dateTimeBr }}
            </span>

            <span v-else>
              {{ order.proposed_at | dateTimeBr }}
            </span>
          </pr-col>
        </pr-row>
        <pr-row v-if="salesman">
          <pr-col style="font-size: 10pt">
            <b>Vendedor: </b> {{ salesman.name }}
          </pr-col>
        </pr-row>

        <template v-if="person.id">
          <br />
          <pr-row>
            <pr-col style="font-size: 10pt">
              <b>Cliente: </b> {{ person.name }}
            </pr-col>
          </pr-row>

          <pr-row>
            <pr-col style="font-size: 10pt">
              <span v-if="!isJuridic">
                <b> CPF</b>: {{ person_document | cpf }}
              </span>
              <span v-if="isJuridic">
                <b> CNPJ</b>: {{ person_document | cnpj }}
              </span>
            </pr-col>
          </pr-row>

          <pr-row>
            <pr-col style="font-size: 10pt">
              <b>Endereço: </b>
              {{ person_address.address }}, {{ person_address.number }} -
              {{ person_address.district }} / {{ person_address.city }}-{{
                person_address.state
              }}
            </pr-col>
          </pr-row>

          <pr-row>
            <pr-col style="font-size: 10pt">
              <b>WhatsApp: </b> {{ person.phone_wa | phone }}
            </pr-col>
          </pr-row>
          <pr-row>
            <pr-col style="font-size: 10pt">
              <b>Email: </b> {{ person.email }}
            </pr-col>
          </pr-row>
        </template>

        <br />
        <pr-row>
          <pr-col class="text-center cabecalho">
            <b>PRODUTOS</b>
          </pr-col>
        </pr-row>
        <table class="table-prod">
          <tr>
            <th class="text-center">COD</th>
            <th class="text-center">Desc</th>
            <th class="text-center">Qt</th>
            <th class="text-center">Unit</th>
            <th class="text-center">Total</th>
          </tr>
          <template v-for="row in orderProducts">
            <tr>
              <td class="text-center">{{ row.base_sku_id }}</td>
              <td class="text-center">{{ row.product }}</td>
              <td class="text-center">{{ row.quantity | decimal(3) }}</td>
              <td class="text-center">{{ row.price | decimal }}</td>
              <td class="text-center">
                <b>{{ (row.quantity * row.price) | decimal }}</b>
              </td>
            </tr>
          </template>
        </table>
        <br />
        <pr-row>
          <pr-col class="text-center cabecalho">
            <b>PAGAMENTO</b>
          </pr-col>
        </pr-row>
        <table class="table-pay">
          <tr>
            <th class="text-center">Forma de Pagamento</th>

            <th class="text-center">Valor</th>
          </tr>
          <tr v-for="orderBill in orderBills">
            <td>
              {{ payment_method[orderBill.payment_method].text }}
            </td>

            <td>
              {{ orderBill.value | moneyBr }}
            </td>
          </tr>
        </table>
        <br />
        <pr-row>
          <pr-col class="text-center cabecalho">
            <b>TOTAIS</b>
          </pr-col>
        </pr-row>
        <table class="table-pay">
          <tr>
            <td>SubTotal</td>

            <td>
              {{ order.product_total | moneyBr }}
            </td>
          </tr>
          <tr>
            <td>Desconto</td>

            <td>
              {{ order.discount | moneyBr }}
            </td>
          </tr>
          <tr>
            <td>Total</td>

            <td>
              {{ order.net_total | moneyBr }}
            </td>
          </tr>
        </table>

        <div class="text-center mb-2 mx-3 informacoes-adicionais">
          <hr style="margin-top: 100px" class="mb-0 color" />
          <small>Assinatura do cliente</small>
        </div>

        <div class="text-center mb-2 informacoes-adicionais">
          <b>Comprovante Não-Fiscal</b>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
import PrRow from "@/components/printers/grid/PrRow";
import PrCol from "@/components/printers/grid/PrCol";
import { jsPDF } from "jspdf";

export default {
  components: { PrRow, PrCol },

  data: function () {
    return {
      salesman: {},
      order: {},
      orderBills: {},
      orderProducts: [],
      person: {},
      person_address: [],
      company: {},
      bills: [],
      addressCompany: {},
      printConfig: {
        itensPerPage: 10,
        billsPerPage: 2,
      },
      payment_method: {
        1: {
          text: "Dinheiro",
          class: "badge-success",
          value: "0",
        },
        2: {
          text: "Cheque",
          class: "badge-secondary",
        },
        3: {
          text: "Cartão de Crédito",
          class: "badge-secondary",
        },
        4: {
          text: "Cartão de Débito",
          class: "badge-secondary",
        },
        5: {
          text: "Crédito Loja",
          class: "badge-info",
        },
        15: {
          text: "Boleto Bancário",
          class: "badge-primary",
        },
        16: {
          text: "Depósito Bancário",
          class: "badge-secondary",
        },
        17: {
          text: "PIX",
          class: "badge-secondary",
        },
        18: {
          text: "Carteira Digital",
          class: "badge-secondary",
        },
        99: {
          text: "Outros",
          class: "badge-secondary",
        },
      },
    };
  },

  mounted() {
    this.$store.commit("pageHasLoaded");
  },

  created() {
    if (this.$route.params.id) {
      axios
        .post(`${process.env.BASE_URL}api/order/edit/${this.$route.params.id}`)
        .then((response) => {
          this.order = response.data.order;
          this.orderBills = response.data.orderBills;
          this.orderProducts = response.data.orderProducts;
          this.person = response.data.person;
          this.person_address = response.data.address;
          this.company = response.data.company;
          this.bills = response.data.bills;
          this.addressCompany = response.data.addressCompany;
          this.salesman = response.data.salesman;

          this.$store.commit("pageHasLoaded");
        })
        .catch((error) => {
          this.error = error;
        });
    } else {
      this.$store.commit("pageHasLoaded");
    }
  },

  computed: {
    baseUrl() {
      return process.env.BASE_URL;
    },
    isJuridic() {
      return this.person.person_type == "j";
    },
    person_document() {
      if (this.isJuridic) {
        return this.person.cnpj ? this.person.cnpj : "";
      }
      if (!this.isJuridic) {
        return this.person.cpf ? this.person.cpf : "";
      }
    },
  },

  methods: {
    print() {
      window.print();
      //      var recipt = document.getElementById("card");
      // console.log(recipt.clientHeight);
      // converte recipt.clientHeight para mm e adiciona 3mm de margem
      // var contentHeight = recipt.clientHeight + 10;
      // var contentWidth = recipt.clientWidth;
      // var doc = new jsPDF("p", "px", [contentWidth, contentHeight]);
      // doc.html(recipt, {
      //   callback: function (doc) {
      //     var newWindow = window.open(
      //       doc.output("bloburl") + "#toolbar=0",
      //       "_blank"
      //     );
      //     newWindow.onload = function () {
      //       newWindow.print();
      //     };
      //     // };
      //   },
      // });
    },

    printNota(order) {
      window.open("/vendas/imprimir/nota/" + this.order.id, "_blank");
    },
  },
};
</script>

<style  >
.table-prod {
  font-size: 10pt;
  border-collapse: collapse;
  border: 0.1px solid rgb(71, 71, 71);
  th {
    border: 0.1px solid rgb(71, 71, 71);
  }
  td {
    border: 0.1px solid rgb(71, 71, 71);
  }
}
.table-pay {
  font-size: 10pt;
  border-collapse: collapse;
  border: 0.1px solid rgb(71, 71, 71);
  width: 100%;
  th {
    border: 0.1px solid rgb(71, 71, 71);
    text-align: center;
  }
  td {
    border: 0.1px solid rgb(71, 71, 71);
    text-align: center;
  }
}
div.card-body {
  padding: 1mm;
}

.card {
  width: 80mm;
  border: none;
}

* {
  font-family: "Arial", sans-serif;
  font-weight: bold;
}

.titulo {
  font-size: 10pt;
  font-weight: bold;
}

.cabecalho {
  font-size: 10pt;
  font-weight: bold;
}

.texto {
  font-size: 10pt;
}

.informacoes-adicionais {
  font-size: 10pt;
}

@media print and (resolution: 300dpi) {
  .card {
    width: 40%;
    height: 100%;
    border: none;
    text-align: justify;
  }
  .text-grid {
    width: 170px;
    word-break: break-word;
    font-size: 9pt;
    font-weight: bold;
  }
  hr.color {
    border: 0.1px solid black;
  }
  small {
    font-weight: bold;
  }
  .not-print {
    display: none;
  }
}
</style>
